module.exports = __webpack_public_path__ + "img/icon-copy-white.1bb20121.svg";